<template>
  <div class="container-timeline-plot">
    <div class="container pt-5 pb-3">
        <div class="row justify-content-center mt-3 mb-3">
          <div class="col-12 col-md-8">
            <h2 class="graph-title">
              Desinformación Encubierta en <i>Fact-Checking</i>
            </h2>
            <div>
              <div class="bajada-graph mt-4">
                Entre marzo de 2020 y septiembre de 2024 se registraron 190 ‘chequeos’ realizados por 17 cuentas de instituciones públicas. La mayoría se empleó para mejorar la imagen de sus funcionarios, desacreditar a periodistas y desviar la atención de irregularidades.

              </div>
            </div>
          </div>
          <div class="col-12 col-md-8 mt-5">
              <div class="grafico">
                  <div class="text-center small text-white">* Cada círculo representa el tuit publicado por cada institución. Clic para ver el tuit.</div>

                  <div id="beeswarm"></div>
              </div>

          </div>
          <div class="col-12 col-md-8">
            <div class="small border-top pt-2 mt-3 mb-3 text-right">
                <div>
                    Fuente y visualización de datos: El Foco. | <a class="text-info" data-toggle="collapse" href="#collapseMetodologia" role="button" aria-expanded="false" aria-controls="collapseMetodologia">
                        Leer nota metodológica
                      </a>
                </div>
            </div>

            <div class="collapse metodologia mt-3" id="collapseMetodologia">
              <ul>
                <li>Este gráfico muestra la distribución de chequeos institucionales realizados entre marzo de 2020 y septiembre de 2024 por 17 cuentas de instituciones públicas. Aunque el análisis principal se enfoca en este período, se incluyen antecedentes de <i>fact-checking</i> institucional desde 2017. El gráfico desglosa los chequeos por temática, coyunturas políticas (procesos electorales, protestas), temas institucionales (inscripción de partidos políticos) y defensas públicas de autoridades.
                </li>
                <li>La visualización destaca momentos clave de mayor actividad en chequeos sobre temas específicos. Por ejemplo, el Ministerio Público concentró sus verificaciones entre abril y octubre de 2023, poco antes del inicio de las investigaciones de la Fiscal de la Nación, Patricia Benavides.</li>
                <li>
                  La Policía Nacional y la PCM realizaron numerosos chequeos durante protestas sociales, como las de principios de 2023 y las de transportistas en octubre de 2024. Por su parte, el JNE y la ONPE intensificaron sus verificaciones durante los procesos electorales.
                </li>
              </ul>
            </div>
          </div>
        </div>
    </div>
    

  </div>
</template>

<style lang="scss">
    .container-timeline-plot {
       background-color: #0f0f0f; 
       color: white;
    }

    .tooltip {
      background-color: #fff;
      pointer-events: none;
      max-width: 320px;
      padding: 10px;
      display: none;
      font-size: 14px !important;

      h4 {
        font-weight: 600;
        font-size: 17px;
        margin: 0;
      }

      .date-label {
        font-size: 14px;
      }
    }
  
    .legend-box {
      width: 16px;
      height: 16px;
      margin: 0 0px 0 0;
      display: inline-block;
    }
  
    .metodologia {
      padding: 20px;
      background-color: #000;
  
      li {
        margin-bottom: 15px;
        font-size: 16px;
        text-align: left;
      }
    }
  
    .legends-level {
      position: absolute;
      right: 0;
      top: -50px;
      text-align: right;
      font-size: 13px;
      font-weight: 600;
      color: #ffffff;
      background: #ffffff17;
      padding: 5px 15px;
  
      @media screen and (max-width: 767px) {
        position: relative;
        top: 0px;
        text-align: center;
        font-size: 15px;
        padding: 10px 0;
      
        .legend-s {
          justify-content: center;    
        }
      }
    }
    
    .y-band {
        .domain {
            stroke: 0;
            stroke-width: 0;
        }

        text {
            font-size: 12px;
        }
    }

    .line-y-band {
        stroke: #e3e3e33d;
        stroke-dasharray: 2px 2px 2px;
    }
  
    h2.graph-title {
      font-family: "Lora";
      font-size: 31px !important;
      font-weight: 900;
      color: #f2e745;

      @media screen and (max-width: 767px){
        font-family: "Lora";
        font-size: 32px;
        font-weight: 900; 
      }

    }
  
    .bajada-graph {
      font-family: "Lora" !important;
      color: #e3e3e3 !important;
      line-height: 1.6em;
      font-size: 19px;
    }

    .circle-tweet {
        &:hover {
            fill: white;
            fill-opacity: 1;
            stroke: white;
            cursor: pointer;
        }
    }
    
  </style>
  

<script>

import * as d3 from 'd3'

export default {
  name: 'Grafico',
  data() {
    return {
        width: 800,
        height: 640
    }
  },
  mounted() {

    this.width = document.querySelector(`#beeswarm`).offsetWidth

    this.renderTimeline()
  },
  methods: {
    renderTimeline() {
      // Sample data (replace with your actual data)
      const data = require(`@/data/timeline_tweets.json`)
      
        const margin = {top: 0, right: 25, bottom: 60, left: 25};

        // Create SVG
        const svg = d3.select("#beeswarm")
            .append("svg")
            .attr("width", this.width)
            .attr("height", this.height);

        // Parse dates
        const parseDate = d3.timeParse("%Y-%m-%d");
        data.forEach(d => d.date = parseDate(d.mes_anio));

        // Get unique institutions and temas generales
        const institutions = [...new Set(data.map(d => d["Institución/ Autoridad"]))];
        const temasGenerales = [...new Set(data.map(d => d["Temas generales"]))];

        // Set up scales
        const xScale = d3.scaleTime()
            .domain(d3.extent(data, d => d.date))
            .range([100, this.width - margin.right]);

        const yScale = d3.scaleBand()
            .domain(institutions)
            .range([margin.top, this.height - margin.bottom])
            .padding(0.7)

        // Color scale for Temas generales
        const colorScale = d3.scaleOrdinal()
            .domain(temasGenerales)
            .range(d3.schemeSet3);

        // Create the simulation
        const simulation = d3.forceSimulation(data)
            .force("x", d3.forceX(d => xScale(d.date)).strength(0.1))
            .force("y", d3.forceY(d => yScale(d["Institución/ Autoridad"]) + yScale.bandwidth() / 2).strength(0.4))
            .force("collide", d3.forceCollide(4))
            .stop();

        // Run the simulation
        for (let i = 0; i < 120; ++i) simulation.tick();

        // Draw the points
        const points = svg.append("g")
            .selectAll("circle")
            .data(data)
            .enter()
            .append("circle")
            .attr("cx", d => d.x)
            .attr("cy", d => d.y)
            .attr("r", 8)
            .attr("fill", d => colorScale(d["Temas generales"]))
            .attr("fill-opacity", `0.8`)
            .attr("stroke", "#333")
            .attr("class", "circle-tweet");

        // Add x-axis
        svg.append("g")
            .attr("transform", `translate(0,${this.height - margin.bottom})`)
            .call(d3.axisBottom(xScale)
            .tickFormat(d3.timeFormat("%Y")))
            .selectAll("text")
            .style("text-anchor", "end")
            .attr("dx", "1em")
            .attr("dy", "1em")
            .attr("transform", "rotate(0)");

        // Add y-axis (institution labels)
        const yBand = svg.append("g")
            .attr("transform", `translate(0,0)`)
            .style("text-anchor", "start")
            .attr('class', `y-band`)
            .call(d3.axisLeft(yScale))

        yBand.selectAll(`line`)
            .attr(`class`, `line-y-band`)
            .attr(`x2`, this.width)
            
        yBand.selectAll(`text`)
            .attr(`class`, `text-y-band`)
            .attr(`x`, 10)
            .attr(`y`, 0)


        // Add tooltip
        const tooltip = d3.select("body").append("div")
            .attr("class", "tooltip")
            .style("opacity", 0);

        points.on("mouseover", function(event, d) {
            tooltip.transition()
                .duration(200)
                .style("opacity", .9)
                .style("display", `block`)

            tooltip.html(`
                <div class="date-label">Fecha: ${d.Fecha}</div>
                <div><h4>${d["Institución/ Autoridad"]}</h4></div>
                <div>Tema: ${d["Temas generales"]}</div>`
            )
            .style("left", (event.pageX + 10) + "px")
            .style("top", (event.pageY - 28) + "px");
        })
        .on("click", function(event, d) {
            window.open(d.Link, '_blank').focus();
        })
        .on("mouseout", function() {
            tooltip.transition()
                .duration(500)
                .style("opacity", 0)
                .style("display", `none`);
        });

    }
  }
}

</script>